import { render, staticRenderFns } from "./goodsDetailV2.vue?vue&type=template&id=5b638c2a&scoped=true"
import script from "./goodsDetailV2.vue?vue&type=script&lang=js"
export * from "./goodsDetailV2.vue?vue&type=script&lang=js"
import style0 from "./goodsDetailV2.vue?vue&type=style&index=0&id=5b638c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b638c2a",
  null
  
)

export default component.exports